import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { AppShell } from './components/AppShell.js';
import { LoadingState } from './components/PageState.js';
import { AuthGate } from './features/auth/AuthGate.js';
import { useUiPreferences } from './i18n/ui-preferences.js';

const WorkItemsPage = lazy(() => import('./pages/WorkItemsPage.js'));
const WorkflowsPage = lazy(() => import('./pages/WorkflowsPage.js'));
const SkillsPage = lazy(() => import('./pages/SkillsPage.js'));
const ProjectsPage = lazy(() => import('./pages/ProjectsPage.js'));
const IntegrationsPage = lazy(() => import('./pages/IntegrationsPage.js'));
const SettingsPage = lazy(() => import('./pages/SettingsPage.js'));
const MeegoConnectPage = lazy(() => import('./pages/MeegoConnectPage.js'));
const MeegoRestartPage = lazy(() => import('./pages/MeegoRestartPage.js'));
const MeegoInterruptPage = lazy(() => import('./pages/MeegoInterruptPage.js'));

export function App() {
  const { t } = useUiPreferences();
  return (
    <AuthGate>
      <Suspense fallback={<LoadingState label={t('正在打开 TCode', 'Opening TCode')} />}>
        <Routes>
          <Route path="meego/connect" element={<MeegoConnectPage />} />
          <Route path="meego/restart" element={<MeegoRestartPage />} />
          <Route path="meego/interrupt" element={<MeegoInterruptPage />} />
          <Route element={<AppShell />}>
            <Route index element={<WorkItemsPage />} />
            <Route path="workflows" element={<WorkflowsPage />} />
            <Route path="skills" element={<SkillsPage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="integrations" element={<IntegrationsPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate replace to="/" />} />
          </Route>
        </Routes>
      </Suspense>
    </AuthGate>
  );
}
